module.exports = __webpack_public_path__ + "assets/views/01_aboutPadcev/treatment_icons_ru.png";